import { render, staticRenderFns } from "./ExamResult.vue?vue&type=template&id=74d19663"
import script from "./ExamResult.vue?vue&type=script&lang=js"
export * from "./ExamResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports